import React from 'react';
import styled from 'styled-components';
import { PageTile, HeaderText } from '@make-software/cspr-design';

import { MessageTable, Container } from '@/components';
import { useGetAllMessages } from '@/hooks';

import { HeroSection } from './hero';

const MessageHistorySection = styled.section(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: ['100%', '720px', '1200px'],
    width: '100%',
    margin: '0 auto',
    padding: '0 12px',
    paddingTop: '48px',
    gap: '24px',
  })
);

const HomeScene = () => (
  <Container>
    <HeroSection />

    <MessageHistorySection>
      <HeaderText size={2}>Message history</HeaderText>
      <PageTile>
        <MessageTable dataLoader={useGetAllMessages} />
      </PageTile>
    </MessageHistorySection>
  </Container>
);

export default HomeScene;
